import React, { useState } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { deleteDisruption } from "../../../store/actions/smrt/disruptionAction";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
const DeleteSingleDisruption = ({ disruption }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const deleteEvent = async (eventId) => {
    dispatch(deleteDisruption(eventId));
  };
  return (
    <>
      <IconButton
        color="error"
        onClick={() => {
          setOpen(true);
        }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
      <Dialog maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle>{t("deleteConfirm.title")}</DialogTitle>

        <DialogContent>
          <Alert severity="warning">{t("deleteConfirm.textSingle")}</Alert>
          <DialogContentText sx={{ pt: 2 }}>
            <Box textAlign={"center"} fontWeight={"bold"}>
              {disruption?.line?.code + " - " + disruption?.type?.toUpperCase()}
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            fullWidth
            onClick={handleClose}
            variant="outlined"
            color="error"
          >
            {tCommon("cancelBtn")}
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={() => {
              deleteEvent(disruption.id);
            }}
          >
            {tCommon("continueBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteSingleDisruption;
